import services from "../services";
import * as types from "./mutation-type";

export const ActionSetSocials = ({commit}, payload) => {
    commit(types.SET_SOCIALS, payload)
}

export const ActionSetCompanySettings = ({commit}, payload) => {
    commit(types.SET_COMPANY_SETTINGS, payload)
}

export const ActionSetCompany = async ({commit}, payload) => {
    commit(types.SET_COMPANY, payload)
    commit(types.SET_FACEBOOK_PIXEL, payload.analytics_settings?.facebook ?? null)
    commit(
        types.SET_GOOGLE_ADS,
        payload.analytics_settings?.google_ads ??
        payload.analytics_settings?.google_manager ??
        null
    )
}

export const ActionSetAccessManagement = async ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.setAccessManagement(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}
